import { IBasePlanLaunchDate } from 'src/types/IBasePlanLaunchDate';

export const initialBasePlanLaunchDateState: IBasePlanLaunchDate = {
    basePlanName: '',
    territoryIds: [],
    startDate: '',
    endDate: ''
};
